module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "channelManage"
    }
  }, [_c('el-row', {
    staticClass: "clearfix",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('el-col', {
    staticClass: "fl",
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    attrs: {
      "size": "medium",
      "type": "success"
    },
    on: {
      "click": _vm.createClass
    }
  }, [_vm._v("新建渠道")])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "fr",
    attrs: {
      "span": 1
    }
  }, [_c('i', {
    staticClass: "el-icon-refresh",
    staticStyle: {
      "font-size": "25px",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.refresh()
      }
    }
  })]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新建分类",
      "visible": _vm.dislogCreate,
      "close-on-click-modal": false,
      "width": "500px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dislogCreate = $event
      },
      "close": function($event) {
        return _vm.emptyDialog('materForm')
      }
    }
  }, [_c('el-form', {
    ref: "materForm",
    attrs: {
      "model": _vm.materForm,
      "label-width": "100px",
      "label-position": _vm.labelPosition,
      "rules": _vm.materFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "渠道名称：",
      "prop": "name"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.materForm.name),
      callback: function($$v) {
        _vm.$set(_vm.materForm, "name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "materForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "排序:",
      "prop": "sort"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.materForm.sort),
      callback: function($$v) {
        _vm.$set(_vm.materForm, "sort", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "materForm.sort"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "启用状态：",
      "prop": "delivery"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-value": 1,
      "inactive-value": -1
    },
    model: {
      value: (_vm.materForm.delivery),
      callback: function($$v) {
        _vm.$set(_vm.materForm, "delivery", $$v)
      },
      expression: "materForm.delivery"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.onSubmit('materForm')
      }
    }
  }, [_vm._v("立即创建")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.emptyDialog('materForm')
      }
    }
  }, [_vm._v("取 消")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "fl",
    staticStyle: {
      "width": "17%"
    }
  }, [_c('el-form', {
    ref: "searchForm",
    attrs: {
      "model": _vm.searchForm,
      "label-width": "100px",
      "label-position": _vm.labelPosition
    }
  }, [_c('el-input', {
    staticStyle: {
      "margin-bottom": "15px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "请输入渠道名称"
    },
    model: {
      value: (_vm.searchForm.channelName),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "channelName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "searchForm.channelName"
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.SubmitSearch('searchForm')
      }
    }
  }, [_vm._v("检索渠道记录")])], 1), _vm._v(" "), _c('el-button', {
    staticClass: "fr",
    staticStyle: {
      "width": "60px",
      "color": "#169BD5"
    },
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.clearFrom()
      }
    }
  }, [_vm._v("重置")])], 1), _vm._v(" "), _c('el-card', {
    staticClass: "box-card fr",
    staticStyle: {
      "width": "80%"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.returnData,
      "border": "",
      "header-cell-style": {
        'text-align': 'center'
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "name",
      "label": "渠道"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "sort",
      "label": "排序"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "delivery",
      "width": "250",
      "label": "状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.delivery == '1') ? _c('span', [_vm._v("启用")]) : _vm._e(), _vm._v(" "), (scope.row.delivery == '-1') ? _c('span', [_vm._v("禁用")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.exitBtn(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")])]
      }
    }])
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-66519ed7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/basicSetting/channelManage.vue
// module id = 1687
// module chunks = 0